import React from 'react';

export const Loader = () => (
  <div className="loader">
    <div className="spinner">
      <div className="double-bounce1" />
      <div className="double-bounce2" />
    </div>
  </div>
);
